export default __webpack_public_path__ + "static/media/hht1_ep06_timeline_04_blank.2af0e5a9.png";